// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"thumbnail_imgContainer__3F-W3","thumbnail":"thumbnail_thumbnail__1sg-B","background":"thumbnail_background__1-6Kf"};